import type { IMessageShape } from './message';
import { messageSchema } from './message';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { forConversation } from '../channels';

export const MESSAGE_SAVED = 'DIALOGUE/MESSAGE_SAVED';

export const messageSavedActionSchema = objectSchemaOf<IMessageSavedAction>({
  type: Joi.string().required().valid(MESSAGE_SAVED),
  payload: messageSchema.required(),
});

export interface IMessageSavedAction {
  type: typeof MESSAGE_SAVED;
  payload: IMessageShape;
}

export const messageSaved = actionCreator({
  type: MESSAGE_SAVED,
  schema: messageSavedActionSchema,
  channels: [forConversation],
});
